export default {
  path: "/registration/:token",
  name: "registration.index",
  component: () => import("@/views/Register/NewUser/Index.vue"),
};
